import { Link } from "react-router-dom";
import { Layout, Section, Eyebrow, ChromeHeading, Card } from "../components/funnel";

export default function PlaceholderPage({ kicker, title, slug }) {
  return (
    <Layout>
      <Section separator={false} data-testid={`placeholder-page-${slug}`}>
        <Card className="fade-up mx-auto max-w-2xl px-6 py-14 text-center sm:px-12">
          <Eyebrow ruled>{kicker}</Eyebrow>
          <ChromeHeading as="h1" className="mt-5 text-4xl sm:text-5xl lg:text-6xl" data-testid="placeholder-title">{title}</ChromeHeading>
          <p className="mx-auto mt-5 max-w-md text-sm text-[#a59f93] sm:text-base">This page is coming in the next phase.</p>
          <Link to="/" className="font-mono-plex mt-8 inline-block text-[11px] uppercase tracking-[0.25em] text-[var(--gold)] transition-opacity hover:opacity-80" data-testid="placeholder-home-link">← Back to home</Link>
        </Card>
      </Section>
    </Layout>
  );
}
